
  import {Component, Vue} from "vue-property-decorator";
  import {IProfilePayment} from "@/modules/Profile/interfaces/profile-payment.interface";
  import {bus} from "@/plugins/bus";
  import {paymentResource} from "@/modules/Profile/resources/payment.resource";

  @Component({})
  export default class SelectCars extends Vue {
    isLoading: boolean = true;
    favoriteList = [];

    async created() {
      await this.getFavoriteList();
    }

    async mounted() {
      bus.$on(IProfilePayment.Events.UpdateCountsCarsPayment, this.getFavoriteList);
    }

    async getFavoriteList() {
      let { response: { data: { result: { cars } }}} = await paymentResource.getSelectedCarsForPayment();
      this.favoriteList = cars;
    }

    async openFavoritePopup() {
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'home',
        dialogName: 'favoriteCars',
        payload: {
          favoriteCars: this.favoriteList,
          paymentCars: true,
        },
      });
    }

    destroyed() {
      bus.$off(IProfilePayment.Events.UpdateCountsCarsPayment);
    }
  }
